import _isEqual from "lodash/isEqual";
import { useRef } from 'react';
import shallowEqual from 'shallowequal';
export default function useLastEqualValue(newValue, equal = Object.is) {
  const lastValueRef = useRef(newValue);
  let checkValueEqual = equal;
  if (equal === 'shallow') {
    checkValueEqual = shallowEqual;
  } else if (equal === 'deep') {
    checkValueEqual = _isEqual;
  }
  if (!checkValueEqual(lastValueRef.current, newValue)) {
    // overwrite value if newValue is not equal with last value
    lastValueRef.current = newValue;
  }
  return lastValueRef.current;
}